import request from '@/utils/request.js'

// 商城列表
export function storeList (data) {
  return request({
    url: '/mallProduct/findPage',
    method: 'POST',
    data
  })
}

// 商城详情
export function getDetail (params) {
  return request({
    url: `/mallProduct/findById/${params}`,
    method: 'GET'
  })
}

// 人脸识别成功或者失败调用接口通知PC
export function isFace (params) {
  return request({
    url: '/mallOrder/isFace',
    method: 'GET',
    params,
    headers: {
      hideLoading: true
    }
  })
}

// 商品兑换时是否符合条件
export function isRedeem (data) {
  return request({
    url: '/mallOrder/isRedeem',
    method: 'POST',
    data
  })
}

// 新增订单
export function addOrder (data) {
  return request({
    url: '/mallOrder/add',
    method: 'POST',
    data
  })
}

// 订单列表
export function orderList (data) {
  return request({
    url: '/mallOrder/findPage',
    method: 'POST',
    data
  })
}

// 订单详情
export function getOrderDetail (params) {
  return request({
    url: `/mallOrder/findById/${params}`,
    method: 'GET'
  })
}

// x豆明细
export function getXList (data) {
  return request({
    url: '/mallPointsConsume/findPage',
    method: 'POST',
    data
  })
}

// X豆统计
export function getXChart (data) {
  return request({
    url: '/mallPointsConsume/getTotal',
    method: 'POST',
    data
  })
}

// 积分明细
export function getPointsList (data) {
  return request({
    url: '/sign/system/getSignScoreList',
    method: 'POST',
    data
  })
}

// 积分统计
export function getPointsChart (params) {
  return request({
    url: '/user/getSignScoreTotal',
    method: 'GET',
    params
  })
}

// 获取密钥
export function sendSecretKey (data) {
  return request({
    url: '/mallOrder/sendSecretKey',
    method: 'POST',
    data
  })
}
